import { css } from '@emotion/react'
import Label from './Label'
import Row from './IndentedRow'
import RecipientsEditor from './RecipientsEditor'

const flexStyle = css`
  flex: 1 0 100%;
`

export default function CcRow({ className, ...rest }) {
  const { ticketId, onUpdate } = rest
  return (
    <Row css={flexStyle} className={className}>
      <Label>CC:</Label>
      <RecipientsEditor
        key={`recipientseditor-cc-${ticketId}`}
        className="grui ml-3"
        type="cc"
        onUpdateCustom={onUpdate}
        {...rest}
      />
    </Row>
  )
}
